import { RegisterModule } from '@/typings/common'
import {
  Procedure as Data,
  ProcedureCollection as Collection,
} from '@/typings/api/Procedure'
import { ProceduresPublicationsApi as Api } from '@/api/resources/Collector/ProceduresApi'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import { ProceduresAdapter as Adapter } from './ProceduresAdapter'
import { MODULE_NAME } from '../utils'


const useOptions = () => ({
  adapter: new Adapter(),
  idName: 'id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as ProceduresStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
